// eslint-disable-next-line import/prefer-default-export
export enum responseCategories {
    OK = 'OK',
    NOT_LOGGED_IN = 'NOT_LOGGED_IN',
    HTTP_ERROR = 'HTTP_ERROR',
    TIMEOUT = 'TIMEOUT',
    RESPONSE_PARSING_ERROR = 'RESPONSE_PARSING_ERROR',
    OFFLINE = 'OFFLINE',
    FORBIDDEN = 'FORBIDDEN',
    WRONG_TOKEN = 'WRONG_TOKEN',
    INVALID_TAB_TOKEN = 'INVALID_TAB_TOKEN',
}

export enum apiRoots {
    ASSESSMENT = '/ICSXapi/assessment/',
    ASYNC = '/ICSXapi/async/',
    CONTENT = '/ICSXapi/content/',
    DASHBOARD = '/ICSXapi/dashboard/',
    EXPORT = '/ICSXapi/export/',
    GRADING = '/ICSXapi/grading/',
    GRADING_XLS_STREAMABLE = '/ICSXapi/grading/xls/',
    HYPOTHESIS = '/internalapi/annotation/',
    KERNEL = '/ICSXapi/kernel/',
    METADATA = '/ICSXapi/metadata/',
    TESTPLAYER = '/ICSXapi/testplayer/',
    SUPERADMIN = '/ICSXapi/superadmin/',
    TESTPLAYERADMIN = '/ICSXapi/testplayeradmin/',
    ADMIN = '/ICSXapi/admin/',
}

export const supportArticleForExplanations = 'https://support.inspera.com/hc/en-us/articles/23495583000989';
export const supportArticleForMarkingWorkflow = 'https://support.inspera.com/hc/en-us/articles/34734582538781';
